import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { MessageClaraDraftSourceItemField } from '@/modules/messenger/_modules/message/models/MessageClaraDraftSourceItemField';

type MessageClaraDraftSourceItemFieldInput = string | Partial<MessageClaraDraftSourceItemField>;

export class MessageClaraDraftSourceItem extends BaseModel {
  sourceId?: string;
  label?: string | null;
  description?: string | null;
  group?: string | null;
  fields: MessageClaraDraftSourceItemField[];

  constructor(model: Partial<MessageClaraDraftSourceItem> = {}) {
    super(model);

    this.sourceId = model.sourceId;
    this.label = model.label;
    this.description = model.description;
    this.group = model.group;
    // Drafts written before fields were labelled send each field as a plain string.
    this.fields = ((model.fields ?? []) as MessageClaraDraftSourceItemFieldInput[]).map(
      (field: MessageClaraDraftSourceItemFieldInput) =>
        new MessageClaraDraftSourceItemField(typeof field === 'string' ? { value: field } : field)
    );
  }
}
